import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-cat-dashboard',
    imports: [RouterModule],
    templateUrl: './cat-dashboard.component.html',
    styleUrls: ['./cat-dashboard.component.scss']
})
export class CatDashboardComponent implements OnInit {

  constructor() { }


  ngOnInit() {
  }

}
